import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCook = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "cook",
	"data-name": "cook",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "chef-toque-hat",
		transform: "matrix(1.1309116,0,0,1.1309116,-0.46160776,-0.46094491)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Union",
				className: "plan2plate-icon round-linecap",
				d: "M 14.52128,3.27842 A 4.13678,4.13678 0 0 0 11.04,1.38 4.13678,4.13678 0 0 0 7.55872,3.27842 3.68,3.68 0 1 0 4.0112,9.5082 220.34276,220.34276 0 0 0 5.014,19.4212 c 0.0782,0.6256 0.57546,1.104 1.2052,1.14448 C 7.17876,20.62732 8.786,20.7 11.04,20.7 c 2.254,0 3.86124,-0.07268 4.8208,-0.13478 0.62974,-0.04048 1.127,-0.51888 1.2052,-1.14448 A 220.34092,220.34092 0 0 0 18.0688,9.5082 3.68,3.68 0 1 0 14.52128,3.27842 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Intersect",
				className: "plan2plate-icon round-linecap",
				d: "m 17.36638,17.18698 c -1.17622,-0.06118 -3.14456,-0.1219 -6.32638,-0.1219 -3.18182,0 -5.15062,0.06072 -6.32638,0.1219"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 1388",
				className: "plan2plate-icon round-linecap",
				d: "M 8.74,9.66 9.2,13.34"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 1389",
				className: "plan2plate-icon round-linecap",
				d: "m 13.34,9.66 -0.46,3.68"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgCook);
export default ForwardRef;
